import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
export function template() {
  const disabled = this.attr("disabled");
  const on = this.attr("on");
  const icon = this.attr("icon") ? this.attr("icon") : "checkmark";
  return /* @__PURE__ */ jsx("div", { sel: ".mp-switch", class: {
    "switch-on": on,
    "switch-off": !on,
    disabled
  }, on: {
    click: disabled ? null : this.helpers.toggleSwitch
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon
  }, class: {
    "show-icon-while-off": this.attr("show-icon-while-off")
  }, "data-sentry-element": "SvgIconEl", "data-sentry-source-file": "template.tsx" }));
}
